import React, { createContext, useContext, useState } from "react";
import axios from "axios";

import AddToGoogleWallet from "./AddToGoogleWallet";
import { GOOGLE_WALLET_FAILED, GOOGLE_WALLET_POPUP_BLOCKED } from "./googleWalletErrors";

const AddToGoogleWalletContext = createContext();

export function useAddToGoogleWalletContext() {
  return useContext(AddToGoogleWalletContext);
}

const AddToGoogleWalletProvider = (props) => {
  const {
    csrfToken,
    orderId,
    addToGoogleWalletIconUrl,
    googleWalletUrlEndpoint,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadGoogleWalletPasses = (e) => {
    e.preventDefault();

    setError(null);

    const popup = window.open("", "_blank");
    if (!popup) {
      setError(GOOGLE_WALLET_POPUP_BLOCKED);
      return;
    }
    popup.opener = null;

    setIsLoading(true);

    const endpoint = googleWalletUrlEndpoint ||
      `/my_orders/${orderId}/google_wallet_url`;

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.get(endpoint)
      .then((response) => {
        popup.location.href = response.data.url;
        setIsLoading(false);
      })
      .catch(() => {
        popup.close();
        setError(GOOGLE_WALLET_FAILED);
        setIsLoading(false);
      });
  };

  const value = {
    csrfToken,
    orderId,
    addToGoogleWalletIconUrl,
    isLoading,
    setIsLoading,
    error,
    downloadGoogleWalletPasses,
  };

  return (
    <AddToGoogleWalletContext.Provider value={value}>
      {props.children}
    </AddToGoogleWalletContext.Provider>
  );
};

const AddToGoogleWalletContainer = (props) => (
  <AddToGoogleWalletProvider {...props}>
    <AddToGoogleWallet />
  </AddToGoogleWalletProvider>
);

export default AddToGoogleWalletContainer;
